
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"30","rx":"15","fill":"#EAEDFF"}}),_c('path',{attrs:{"d":"M16.666 16.88v6.456H8.333a6.667 6.667 0 018.333-6.457zM15 15.835c-2.763 0-5-2.238-5-5 0-2.763 2.237-5 5-5 2.762 0 5 2.237 5 5 0 2.762-2.238 5-5 5zm5 3.333v-2.5h1.666v2.5h2.5v1.667h-2.5v2.5H20v-2.5h-2.5v-1.667H20z","fill":"#2B4BFF"}})])
          )
        }
      }
    